/* PunkPot theme script: header cart drawer (real Shopify cart) on every page,
   plus the homepage views (shop, gallery, journal, policies). */
(() => {
const $ = id => document.getElementById(id);
const esc = s => String(s).replace(/[&<>"]/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const money = n => "$" + Number(n).toFixed(2);
const IS_HOME = !!document.querySelector('[data-section="home"]');
const imgW = (u, w) => !u ? "" : u + (u.includes("?") ? "&" : "?") + "width=" + w;

/* ---------- toast ---------- */
let toastTimer;
function toast(msg){ const t = $("toast"); if (!t) return; t.textContent = msg; t.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(() => t.hidden = true, 2400); }

/* ---------- overlays ---------- */
let lastFocus = null, openHandle = null;
let pushedProduct = false;
function closeOverlays(fromNav){
  if (!fromNav && pushedProduct && location.hash.startsWith("#p-")) { pushedProduct = false; history.back(); return; }   // closing a product pop-up undoes its history step
  ["scrim","pview","drawer","gview"].forEach(id => { if ($(id)) $(id).hidden = true; });
  openHandle = null;
  if (lastFocus && lastFocus.focus) lastFocus.focus();
}
function showOverlay(id, focusSel){
  lastFocus = document.activeElement;
  $("scrim").hidden = false; $(id).hidden = false;
  const f = focusSel ? $(id).querySelector(focusSel) : null; if (f) f.focus();
}

/* ---------- cart: Shopify's real cart, shared with every page ---------- */
let CART = {items: [], item_count: 0, total_price: 0};
const cartQty = v => CART.items.filter(i => String(i.variant_id) === String(v)).reduce((s, i) => s + i.quantity, 0);
async function loadCart(){
  try { CART = await (await fetch("/cart.js", {headers:{Accept:"application/json"}})).json(); } catch(_) {}
  renderCart(); refreshCards(); syncAddButton();
}
async function addVariant(id, title){
  const r = await fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json", Accept:"application/json"},
    body: JSON.stringify({items:[{id:Number(id), quantity:1}]})});
  const j = await r.json().catch(() => ({}));
  if (!r.ok) { toast(j.description || "Couldn't add that. It may be sold out."); return false; }
  await loadCart(); toast("Added: " + title); return true;
}
async function changeLine(key, q){
  await fetch("/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json", Accept:"application/json"}, body: JSON.stringify({id:key, quantity:q})});
  await loadCart();
}
function renderCart(){
  const n = CART.item_count || 0;
  if ($("cart-count")) { $("cart-count").hidden = !n; $("cart-count").textContent = n; }
  const lines = $("lines"); if (!lines) return;
  if (!CART.items.length) {
    lines.innerHTML = `<div class="cart-empty">Your cart is empty.<br><br><a class="btn-ghost" href="/#ceramics" data-go="ceramics">Shop ceramics</a> <a class="btn-ghost" href="/#tools" data-go="tools">Shop tools</a></div>`;
  } else {
    lines.innerHTML = "";
    CART.items.forEach(it => {
      const row = document.createElement("div");
      row.className = "line";
      const variant = it.variant_title && it.variant_title !== "Default Title" ? ` · ${esc(it.variant_title)}` : "";
      row.innerHTML = `<img src="${esc(imgW(it.image, 160))}" alt="">
        <div><a class="lt" href="${esc(it.url)}">${esc(it.product_title)}</a><div class="lm">${money(it.final_price / 100)}${variant}</div>
          <div class="qty"><button type="button" data-dec aria-label="Fewer">−</button><span>${it.quantity}</span><button type="button" data-inc aria-label="More">+</button></div></div>
        <div class="rp"><span class="price">${money(it.final_line_price / 100)}</span><button type="button" class="rm" data-rm>Remove</button></div>`;
      row.querySelector("[data-rm]").addEventListener("click", () => changeLine(it.key, 0));
      row.querySelector("[data-dec]").addEventListener("click", () => changeLine(it.key, it.quantity - 1));
      row.querySelector("[data-inc]").addEventListener("click", () => changeLine(it.key, it.quantity + 1));
      lines.appendChild(row);
    });
  }
  if ($("subtotal")) $("subtotal").textContent = money((CART.total_price || 0) / 100);
  const co = $("pp-checkout");
  if (co) {
    if (n) { co.removeAttribute("aria-disabled"); co.textContent = `Check out · ${money(CART.total_price / 100)}`; }
    else { co.setAttribute("aria-disabled", "true"); co.textContent = "Check out"; }
  }
}
if ($("cart-open")) $("cart-open").addEventListener("click", () => { loadCart(); showOverlay("drawer", "[data-close]"); });
if ($("scrim")) $("scrim").addEventListener("click", () => closeOverlays());
document.querySelectorAll("[data-close]").forEach(b => b.addEventListener("click", () => closeOverlays()));
document.addEventListener("keydown", e => { if (e.key === "Escape") closeOverlays(); });
if ($("pview")) $("pview").addEventListener("click", e => { if (e.target === $("pview")) closeOverlays(); });

/* ---------- signup message after the Shopify form posts ---------- */
const msg = $("signup-msg");
if (msg && window.PP_SIGNED_UP) { msg.textContent = "You're in. I'll email you when new stuff drops."; msg.classList.add("ok"); }
if (msg && window.PP_SIGNUP_ERR) { msg.textContent = "That didn't go through. Check your email and try again."; }

/* ---------- shop (homepage #ceramics / #tools) ---------- */
const cfgEl = $("pp-shop-config");
const CFG = cfgEl ? JSON.parse(cfgEl.textContent) : null;
const clean = a => (a || []).map(s => s.trim()).filter(Boolean);
let PRODUCTS = [], SOURCE = "loading";
const DEPTS = CFG ? CFG.depts : {ceramics:{filters:[]}, tools:{filters:[]}};
const HIDDEN = CFG ? clean(CFG.hidden) : [];
const DIGITAL = CFG ? clean(CFG.digital) : [];
const PAGE_ONLY = CFG ? clean(CFG.pageOnly) : [];
const TOOL_COLS = CFG ? [...new Set([...DEPTS.tools.filters.map(f => f.col).filter(Boolean), ...clean(CFG.toolsExtra)])] : [];
const ALL_COLS = CFG ? [...new Set([...DEPTS.ceramics.filters.map(f => f.col), ...TOOL_COLS, ...HIDDEN, ...DIGITAL].filter(Boolean))] : [];
const hiddenOnSite = p => p.c.some(c => HIDDEN.includes(c));
const deptOf = p => p.c.some(c => TOOL_COLS.includes(c)) ? "tools" : "ceramics";
const isDigital = p => p.c.some(c => DIGITAL.includes(c));
const maxQty = p => (deptOf(p) === "ceramics" || isDigital(p)) ? 1 : 9;
function inFilter(p, f){
  if (!f || f.id === "all") return true;
  return p.c.includes(f.col) && !clean(f.exclude).some(e => p.c.includes(e));
}
const filterById = (dept, id) => DEPTS[dept].filters.find(f => f.id === id);
const byHandle = h => PRODUCTS.find(p => p.h === h);
const listed = () => PRODUCTS.filter(p => !hiddenOnSite(p));

async function fromStore(){
  const get = async u => { const r = await fetch(u, {headers:{Accept:"application/json"}}); if (!r.ok) throw new Error(r.status); return r.json(); };
  let all = [], page = 1;
  while (page < 20) { const j = await get(`/products.json?limit=250&page=${page}`); if (!j.products.length) break; all = all.concat(j.products); page++; }
  const cols = {};
  await Promise.all(ALL_COLS.map(async c => {
    let pg = 1;
    while (pg < 10) { const j = await get(`/collections/${c}/products.json?limit=250&page=${pg}`); if (!j.products.length) break;
      j.products.forEach(p => (cols[p.handle] = cols[p.handle] || []).push(c)); pg++; }
  }));
  const sales = window.PP_SALES || {};
  const strip = h => new DOMParser().parseFromString(h || "", "text/html").body.textContent.replace(/\s+/g, " ").trim();
  all.sort((a, b) => b.created_at.localeCompare(a.created_at));
  PRODUCTS = all.filter(p => p.variants && p.variants.length).map((p, i) => {
    const v = p.variants.find(x => x.available) || p.variants[0];
    return {i, h:p.handle, t:p.title, v:String(v.id), p:+v.price, a:p.variants.some(x => x.available), multi:p.variants.length > 1 || PAGE_ONLY.includes(p.handle),
      c:cols[p.handle] || [], d:strip(p.body_html).slice(0, 420), img: imgW(p.images && p.images[0] && p.images[0].src, 600), s:sales[p.handle] || 0};
  });
  const ranked = PRODUCTS.filter(p => p.s > 0).sort((a, b) => b.s - a.s);
  PRODUCTS.forEach(p => p.r = p.s > 0 ? ranked.indexOf(p) : Infinity);
  SOURCE = "live";
}

const STATE = {
  ceramics: {f:"all", q:"", sort:(DEPTS.ceramics && DEPTS.ceramics.sort) || "new", stock:false, shown:24},
  tools: {f:"all", q:"", sort:(DEPTS.tools && DEPTS.tools.sort) || "best", stock:false, shown:24}
};
function buildShop(dept){
  const host = document.querySelector(`[data-shop-view="${dept}"]`); if (!host) return;
  const items = listed().filter(p => deptOf(p) === dept);
  const chips = DEPTS[dept].filters.map(f => {
    const n = items.filter(p => inFilter(p, f)).length;
    return n || f.id === "all" ? `<button type="button" class="chip" data-f="${esc(f.id)}">${esc(f.label)} <span>${n}</span></button>` : "";
  }).join("");
  host.innerHTML = `
    <div class="shopbar">
      <div class="chips-scroll"><div class="chips" role="group" aria-label="Collections">${chips}</div></div>
      <div class="tools-row">
        <input type="search" id="q-${dept}" placeholder="Search ${dept}" aria-label="Search ${dept}">
        <select id="sort-${dept}" aria-label="Sort">
          <option value="best">Best selling</option><option value="new">Newest</option>
          <option value="low">Price: low to high</option><option value="high">Price: high to low</option><option value="az">A to Z</option>
        </select>
        <label class="check"><input type="checkbox" id="stock-${dept}"> In stock only</label>
        <span class="result-count mono" data-count></span>
      </div>
    </div>
    <div class="pgrid" data-grid></div>
    <div class="more-wrap"><button type="button" class="btn-ghost" data-more hidden>Show more</button></div>`;
  const st = STATE[dept];
  host.querySelectorAll(".chip").forEach(b => b.addEventListener("click", () => { st.f = b.dataset.f; st.shown = 24; renderShop(dept); }));
  host.querySelector(`#q-${dept}`).addEventListener("input", e => { st.q = e.target.value.trim().toLowerCase(); st.shown = 24; renderShop(dept); });
  host.querySelector(`#sort-${dept}`).value = st.sort;
  host.querySelector(`#sort-${dept}`).addEventListener("change", e => { st.sort = e.target.value; renderShop(dept); });
  host.querySelector(`#stock-${dept}`).addEventListener("change", e => { st.stock = e.target.checked; st.shown = 24; renderShop(dept); });
  host.querySelector("[data-more]").addEventListener("click", () => { st.shown += 24; renderShop(dept); });
  renderShop(dept);
}
function renderShop(dept){
  const host = document.querySelector(`[data-shop-view="${dept}"]`); if (!host || !host.querySelector("[data-grid]")) return;
  const st = STATE[dept];
  host.querySelectorAll(".chip").forEach(b => b.setAttribute("aria-pressed", b.dataset.f === st.f ? "true" : "false"));
  const f = filterById(dept, st.f);
  let list = listed().filter(p => deptOf(p) === dept && inFilter(p, f));
  if (st.stock) list = list.filter(p => p.a);
  if (st.q) list = list.filter(p => p.t.toLowerCase().includes(st.q));
  const sorters = {best:(a,b) => (b.a - a.a) || (a.r - b.r) || (isDigital(a) - isDigital(b)) || (a.i - b.i),
    new:(a,b) => (b.a - a.a) || (isDigital(a) - isDigital(b)) || (a.i - b.i),
    low:(a,b) => a.p - b.p, high:(a,b) => b.p - a.p, az:(a,b) => a.t.localeCompare(b.t)};
  list.sort(sorters[st.sort] || sorters.new);
  const pins = clean(DEPTS[dept].pin);
  if (pins.length) { const rank = p => { const k = pins.indexOf(p.h); return k < 0 ? Infinity : k; }; list.sort((a, b) => (rank(a) - rank(b)) || 0); }
  const grid = host.querySelector("[data-grid]");
  grid.innerHTML = list.length ? "" : `<p class="empty">Nothing matches that. Try another collection or clear the search.</p>`;
  list.slice(0, st.shown).forEach(p => grid.appendChild(productCard(p)));
  const more = host.querySelector("[data-more]");
  more.hidden = list.length <= st.shown;
  more.textContent = `Show more (${list.length - Math.min(st.shown, list.length)} left)`;
  host.querySelector("[data-count]").textContent = `${Math.min(st.shown, list.length)} of ${list.length}`;
}
function refreshCards(){ ["ceramics","tools"].forEach(renderShop); }
function isTopSeller(p){
  if (!(p.r < Infinity)) return false;
  return listed().filter(x => deptOf(x) === deptOf(p) && x.a && x.r < Infinity).sort((a,b) => a.r - b.r).slice(0, 6).includes(p);
}
function productCard(p){
  const el = document.createElement("article");
  el.className = "pcard" + (p.a ? "" : " sold");
  const inCart = cartQty(p.v) > 0;
  const tag = !p.a ? `<span class="badge sold mono">Sold out</span>` : isTopSeller(p) ? `<span class="badge hot mono">Best seller</span>` : isDigital(p) ? `<span class="badge mono">.STL</span>` : "";
  const label = !p.a ? "Sold out" : p.multi ? "Choose options" : inCart ? "In cart" : "Add to cart";
  el.innerHTML = `
    <button type="button" class="ph" data-open="${esc(p.h)}" aria-label="View ${esc(p.t)}">${tag}<img src="${esc(p.img)}" alt="" loading="lazy"></button>
    <div class="meta"><h3><button type="button" data-open="${esc(p.h)}">${esc(p.t)}</button></h3><span class="price">${money(p.p)}</span></div>
    <button type="button" class="add${inCart ? " in" : ""}" data-add="${esc(p.h)}" ${p.a ? "" : "disabled"}>${label}</button>`;
  const img = el.querySelector("img"); img.addEventListener("error", () => img.remove());
  return el;
}
function addProduct(h){
  const p = byHandle(h); if (!p || !p.a) return;
  if (p.multi) { location.href = "/products/" + p.h; return; }   // products with options use their own page
  if (cartQty(p.v) >= maxQty(p)) { toast("Only one of this piece"); return; }
  addVariant(p.v, p.t);
}
function openProduct(h){
  const p = byHandle(h); if (!p) return;
  openHandle = h;
  $("pv-img").src = p.img; $("pv-img").alt = p.t;
  const f = DEPTS[deptOf(p)].filters.find(f => f.id !== "all" && inFilter(p, f));
  $("pv-crumb").textContent = (deptOf(p) === "tools" ? "Tools" : "Ceramics") + (f ? " / " + f.label : "");
  $("pv-title").textContent = p.t;
  $("pv-price").textContent = money(p.p) + (p.a ? "" : " · Sold out");
  $("pv-desc").textContent = p.d || (deptOf(p) === "ceramics" ? "Handmade in the PunkPot studio. One of one." : "");
  $("pv-ext").href = "/products/" + p.h;
  syncAddButton();
  showOverlay("pview", "[data-close]");
}
function syncAddButton(){
  if (!openHandle || !$("pv-add")) return;
  const p = byHandle(openHandle), b = $("pv-add"), q = cartQty(p.v);
  b.disabled = !p.a || (!p.multi && q >= maxQty(p));
  b.textContent = !p.a ? "Sold out" : p.multi ? "Choose options" : q >= maxQty(p) ? "In your cart" : q ? `Add another (${q} in cart)` : "Add to cart";
}
if ($("pv-add")) $("pv-add").addEventListener("click", () => addProduct(openHandle));
function stockNote(){
  const txt = SOURCE === "live" ? "Live from Shopify" : "Couldn't load products. Refresh to try again.";
  document.querySelectorAll("[data-stock-note]").forEach(n => n.textContent = txt);
}

/* ---------- gallery lightbox ---------- */
const G = [...document.querySelectorAll("#gallery-grid .gitem")];
let gIndex = 0;
function openGallery(i){
  if (!G.length) return;
  gIndex = (i + G.length) % G.length;
  const g = G[gIndex];
  $("gv-img").src = g.dataset.full; $("gv-img").alt = g.dataset.title || "";
  $("gv-cap").textContent = `${g.dataset.title || ""} · Sold · ${gIndex + 1} / ${G.length}`;
  if ($("gview").hidden) showOverlay("gview", "#gv-next");
}
G.forEach((b, i) => b.addEventListener("click", () => openGallery(i)));
if ($("gv-prev")) { $("gv-prev").addEventListener("click", () => openGallery(gIndex - 1)); $("gv-next").addEventListener("click", () => openGallery(gIndex + 1)); }
if ($("gview")) $("gview").addEventListener("click", e => { if (e.target === $("gview")) closeOverlays(); });
document.addEventListener("keydown", e => {
  if (!$("gview") || $("gview").hidden) return;
  if (e.key === "ArrowRight") openGallery(gIndex + 1);
  if (e.key === "ArrowLeft") openGallery(gIndex - 1);
});

/* ---------- homepage views: #home #ceramics #tools #gallery #journal #policies, a filter like #lexicon, or a product like #p-yawn ---------- */
const VIEWS = [...new Set([...document.querySelectorAll("[data-section]")].map(s => s.dataset.section))];
function show(token){
  if (!IS_HOME) return;
  let v = token || "home", product = null, filter = null;
  if (v.startsWith("p-") && byHandle(v.slice(2))) { product = v.slice(2); v = deptOf(byHandle(product)); }
  for (const d of ["ceramics","tools"]) if (DEPTS[d] && DEPTS[d].filters.some(f => f.id === token && f.id !== "all")) { v = d; filter = token; }
  if (!VIEWS.includes(v)) v = "home";
  if (filter) { STATE[v].f = filter; STATE[v].shown = 24; renderShop(v); }
  closeOverlays(true);
  document.querySelectorAll("[data-section]").forEach(s => s.hidden = s.dataset.section !== v);
  document.querySelectorAll("nav.main a").forEach(a => {
    const t = (a.getAttribute("href") || "").split("#")[1];
    if (t && t === v) a.setAttribute("aria-current", "page"); else a.removeAttribute("aria-current");
  });
  if (v !== curView || filter) window.scrollTo(0, 0);
  curView = v;
  if (product) openProduct(product);
}
let curView = null;
/* each view gets its own history step, so the browser Back button walks back through the site */
function go(v){
  if (!IS_HOME) { location.href = "/#" + v; return; }
  try { if (location.hash.slice(1) !== v) history.pushState(null, "", "#" + v); } catch(_) {}
  show(v);
}
document.addEventListener("click", e => {
  const pa = e.target.closest('a[href^="#pol-"]');
  if (pa) { e.preventDefault(); const t = document.getElementById(pa.getAttribute("href").slice(1)); if (t) t.scrollIntoView({behavior:"smooth"}); return; }
  const o = e.target.closest("[data-open]");
  if (o) {
    if (IS_HOME && byHandle(o.dataset.open)) { try { history.pushState(null, "", "#p-" + o.dataset.open); pushedProduct = true; } catch(_) {} }
    openProduct(o.dataset.open); return;
  }
  const ad = e.target.closest("[data-add]"); if (ad) { addProduct(ad.dataset.add); return; }
  const g = e.target.closest("[data-go]"); if (g && IS_HOME) { e.preventDefault(); closeOverlays(); go(g.dataset.go); return; }
  const a = e.target.closest("a[data-view]");
  if (a && IS_HOME) { e.preventDefault(); go(a.dataset.view); }
});
window.addEventListener("popstate", () => { pushedProduct = location.hash.startsWith("#p-"); show(location.hash.slice(1)); });

/* ---------- start ---------- */
loadCart();
if (IS_HOME) {
  show(location.hash.slice(1));
  if (CFG) {
    fromStore().catch(() => { SOURCE = "error"; }).then(() => {
      stockNote(); buildShop("ceramics"); buildShop("tools");
      const t = location.hash.slice(1);
      if (t && (t.startsWith("p-") || ["ceramics","tools"].some(d => DEPTS[d].filters.some(f => f.id === t)))) show(t);
    });
  }
}
})();
